module.exports = __webpack_public_path__ + "Edufin-5794b1fa.webp";